/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Type_NoneInputs */

const fr_load_type_none = /** @type {(inputs: Load_Type_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune`)
};

/**

* @param {Load_Type_NoneInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const load_type_none = /** @type {((inputs?: Load_Type_NoneInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Type_NoneInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_load_type_none(inputs)
});